import { render, staticRenderFns } from "./SalersDetail.vue?vue&type=template&id=16a7d3f3&"
import script from "./SalersDetail.vue?vue&type=script&lang=js&"
export * from "./SalersDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a7d3f3')) {
      api.createRecord('16a7d3f3', component.options)
    } else {
      api.reload('16a7d3f3', component.options)
    }
    module.hot.accept("./SalersDetail.vue?vue&type=template&id=16a7d3f3&", function () {
      api.rerender('16a7d3f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SalersDetail.vue"
export default component.exports